import React from 'react';
import SlickSlider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import styled from 'styled-components';
import {
  standardColours,
  greyColours,
  brandColours,
  fontSize,
  standardTransition,
} from '../../styles';

const StyledSlider = styled(SlickSlider)`
  position: relative;

  .slick-arrow {
    position: absolute;
    overflow: hidden;
    z-index: 1;
    height: ${({ arrowSize }) =>
      arrowSize === 'small' ? '30' : arrowSize === 'large' ? '60' : '50'}px;
    width: ${({ arrowSize }) =>
      arrowSize === 'small' ? '30' : arrowSize === 'large' ? '60' : '50'}px;
    ${fontSize(0)};
    text-align: center;
    background: ${standardColours.white};
    border: none;
    border-radius: 50%;
    transition: ${standardTransition('background-color')};

    &:after {
      content: '';
      display: inline-block;
      height: ${({ arrowSize }) =>
        arrowSize === 'small' ? '6' : arrowSize === 'large' ? '12' : '9'}px;
      width: ${({ arrowSize }) =>
        arrowSize === 'small' ? '6' : arrowSize === 'large' ? '12' : '9'}px;
      border: 2px solid ${brandColours.primary};
      border-top: 0;
      border-left: 0;
      transition: ${standardTransition('border-color')};
    }

    &.slick-prev {
      &:after {
        transform: translateX(2px) rotate(135deg);
      }
    }

    &.slick-next {
      &:after {
        transform: translateX(-2px) rotate(-45deg);
      }
    }

    &:hover {
      background-color: ${brandColours.nonary};

      &:after {
        border-color: ${standardColours.white};
      }
    }
  }

  .slick-dots {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);

    li {
      display: inline-block;
      margin-left: 10px;

      button {
        padding: 0;
        height: 9px;
        width: 9px;
        ${fontSize(0)};
        background-color: ${({ dotsAltColours }) =>
          dotsAltColours
            ? standardColours.white
            : greyColours.darkPurplishGrey};
        border: none;
        border-radius: 50%;
        opacity: 0.85;
      }

      &.slick-active {
        button {
          background-color: ${({ dotsAltColours }) =>
            dotsAltColours ? brandColours.septenary : brandColours.tertiary};
          opacity: 1;
        }
      }

      &:first-child {
        margin-left: 0;
      }
    }
  }
`;

export const Slider = ({ numSlides, sliderOptions, children, ...props }) => (
  <StyledSlider numSlides={numSlides} {...sliderOptions} {...props}>
    {children}
  </StyledSlider>
);
